import React from "react";
import { Input, Select, Radio } from "antd";
import {
  SearchOutlined,
  TableOutlined,
  CalendarOutlined,
} from "@ant-design/icons";

interface ChequeStatus {
  id: string;
  name: string;
}

interface ChequeFiltersProps {
  viewMode: "table" | "calendar";
  onViewModeChange: (mode: "table" | "calendar") => void;
  searchInput: string;
  onSearchChange: (v: string) => void;
  typeFilter: string | null;
  onTypeChange: (v: string | null) => void;
  statusFilter: string | null;
  onStatusChange: (v: string | null) => void;
  chequeStatuses: ChequeStatus[];
}

export const ChequeFilters: React.FC<ChequeFiltersProps> = ({
  viewMode,
  onViewModeChange,
  searchInput,
  onSearchChange,
  typeFilter,
  onTypeChange,
  statusFilter,
  onStatusChange,
  chequeStatuses,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* View toggle */}
      <Radio.Group
        value={viewMode}
        onChange={(e) => onViewModeChange(e.target.value)}
        optionType="button"
        buttonStyle="outline"
        size="middle"
      >
        <Radio.Button value="table">
          <TableOutlined /> Table
        </Radio.Button>
        <Radio.Button value="calendar">
          <CalendarOutlined /> Calendar
        </Radio.Button>
      </Radio.Group>

      <Select
        allowClear
        placeholder="Direction"
        value={typeFilter}
        onChange={onTypeChange}
        className="w-36"
      >
        <Select.Option value="in">Inward</Select.Option>
        <Select.Option value="out">Outward</Select.Option>
      </Select>

      <Select
        allowClear
        placeholder="Status"
        value={statusFilter}
        onChange={onStatusChange}
        className="w-36"
      >
        {chequeStatuses.map((s) => (
          <Select.Option key={s.id} value={s.id}>
            {s.name}
          </Select.Option>
        ))}
      </Select>

      <Input
        placeholder="Cheque no, bank, payee..."
        prefix={<SearchOutlined />}
        value={searchInput}
        onChange={(e) => onSearchChange(e.target.value)}
        allowClear
        className="w-60"
      />
    </div>
  );
};
